import { IntegrationSyncSelectOption, SingleSelectInput } from "components";
import { IntegrationEntitySyncStatusEnum } from "enums/integration-entity-sync-status.enum";
import { observer } from "mobx-react";
import { FC, useCallback } from "react";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import { TOpenViewSyncNegotiatorExtendedData } from "types/openview.type";
import { TSelectValue } from "types/select-input.type";

interface IProps {
  accountStore: UserAccountStore;
  record: TOpenViewSyncNegotiatorExtendedData;
  onChange: (syncPair: TOpenViewSyncNegotiatorExtendedData) => void;
}

export const OpenViewNegotiatorSyncSelect: FC<IProps> = observer(
  ({ accountStore, record, onChange }) => {
    const openViewNegotiatorOptions =
      accountStore.accountIntegrationsStore.accountIntegrationOpenViewStore
        .accountIntegrationOpenViewNegotiatorsStore.openViewNegotiatorsOptions;

    const handleChange = useCallback(
      (openViewNegotiatorId: TSelectValue<string>) => {
        onChange({
          openViewNegotiatorId: openViewNegotiatorId || null,
          userAccountId: record.userAccountId,
          user: record.user,
          userFullName: record.userFullName,
          syncStatus: IntegrationEntitySyncStatusEnum.NOT_SYNCED,
        });
      },
      [onChange, record]
    );

    return (
      <SingleSelectInput
        value={record.openViewNegotiatorId}
        clearable={true}
        options={openViewNegotiatorOptions}
        onChange={handleChange}
        optionComponent={optionProps => (
          <IntegrationSyncSelectOption optionProps={optionProps} />
        )}
      />
    );
  }
);
